import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import "./styles/global.css";
import Header from "./components/global/header";
import Footer from "./components/global/footer";
import { ThemeProvider, useTheme } from "./utils/theme";

const Contact = lazy(() => import("./components/contact"));
const Services = lazy(() => import("./components/services"));
const Resume = lazy(() => import("./components/resume"));
const Home = lazy(() => import("./components/Home"));
const ProjectSingle = lazy(() => import("./components/project-single"));
const Login = lazy(() => import("./components/auth/login"));
const ProjectGallery = lazy(() => import("./components/project-gallery"));
const AboutMe = lazy(() => import("./components/about-me"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard"));
const Blog = lazy(() => import("./components/Blog"));
const BlogPost = lazy(() => import("./components/BlogPost"));

function App() {
  return (
    <ThemeProvider>
      <Site />
    </ThemeProvider>
  );
}

function Site() {
  const { theme } = useTheme();

  return (
    <div className={`App site-theme-${theme}`} data-theme={theme}>
      <Header />
      <Suspense fallback={<main className="route-loading">Loading…</main>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/project-single" element={<ProjectSingle />} />
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/login" element={<Login />} />
          <Route path="/work" element={<ProjectGallery />} />
          <Route path="/about-me" element={<AboutMe />} />
        </Routes>
      </Suspense>
      <Footer />
    </div>
  );
}

export default App;
